import React from 'react';
import moment from "moment";

interface DateRangeDescriptionProps {
    fromISOTimestamp: string;
    toISOTimestamp: string;
}

const DateRangeDescription = (props: DateRangeDescriptionProps) => {

    const from = moment(props.fromISOTimestamp);
    const to = moment(props.toISOTimestamp);

    if (from.isSame(to, 'day')) {
        const fromTime = from.format('HH:mm');
        if (fromTime === to.format('HH:mm')) {
            if (fromTime === "00:00") {
                return (
                    <span>{from.format("DD/MM/YYYY")}</span>
                )
            } else {
                return (
                    <span>{from.format("DD/MM/YYYY")}<br />{fromTime}</span>
                )
            }
        }
        return (
            <span>{from.format("DD/MM/YYYY")}<br />{fromTime} - {to.format("HH:mm")}</span>
        )
    }
    return (
        <span>{from.format("DD/MM/YYYY HH:mm")}<br />{to.format("DD/MM/YYYY HH:mm")}</span>
    )
}

export default DateRangeDescription;
